//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    content: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    value: '',
    editing: false,
  }),
  mounted() {
    this.value = this.content;
  },
  methods: {
    close() {
      this.editing = false;
      this.$emit('close');
    },
  },
};
